import querystring from "querystring";
import React, { useContext, useEffect, useState } from "react";
import { Box } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { generateOnePassConsentUrl, MigrationNudgeContainer, URL_ONEPASS_SHOP } from "@catchoftheday/onepass";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ShopMigrationNudge = function ShopMigrationNudge() {
  var _useState = useState({}),
      currentQuery = _useState[0],
      setCurrentQuery = _useState[1];

  var _useContext = useContext(CustomerContext),
      customerData = _useContext.data;

  var _ref = customerData || {},
      membership = _ref.membership;

  useEffect(function () {
    if (typeof globalThis !== "undefined") {
      setCurrentQuery(querystring.parse(globalThis.location.search.substring(1)));
    }
  }, []);
  return ___EmotionJSX(React.Fragment, null, (membership === null || membership === void 0 ? void 0 : membership.eligibleForMigration) && ___EmotionJSX(Box, {
    maxWidth: "1260px",
    py: 4,
    px: 3,
    m: "0 auto"
  }, ___EmotionJSX(MigrationNudgeContainer, {
    CTAUrl: generateOnePassConsentUrl(URL_ONEPASS_SHOP, currentQuery)
  })));
};